import {
  deselectGifteeBoxTemplate,
  selectGifteeBoxTemplate
} from '@console/actions/actions';
import type { AppThunkDispatch } from '@console/actions/thunkType';
import DisplaySelectedGifteeBoxConfigForBulkProject from '@console/components/project/gifteeBoxConfigs/exchangeReport/DisplaySelectedGifteeBoxConfigForBulkProject';
import type { AppState } from '@console/reducers';
import type { LocalGifteeBoxConfig } from '@console/reducers/projects';
import { getSelectedGifteeBoxConfig } from '@console/selectors/projectDetail/gifteeBoxConfigs';
import { getSelectedBulkGifteeBoxIssueConfigExchangeEndLabel } from '@console/selectors/projectDetail/gifteeBoxConfigs/bulkGifteeBoxConfigs';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  selectedGifteeBoxConfig: getSelectedGifteeBoxConfig(state),
  exchangeableEndLabel:
    getSelectedBulkGifteeBoxIssueConfigExchangeEndLabel(state)
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  selectGifteeBoxTemplate: (
    gifteeBoxTemplate: LocalGifteeBoxConfig['gifteeBoxTemplate']
  ) => dispatch(selectGifteeBoxTemplate(gifteeBoxTemplate)),
  deselectGifteeBoxTemplate: () => dispatch(deselectGifteeBoxTemplate())
});

export type DisplaySelectedGifteeBoxConfigForBulkProjectMappedFromState =
  ReturnType<typeof mapStateToProps>;
export type DisplaySelectedGifteeBoxConfigForBulkProjectMappedFromDispatch =
  ReturnType<typeof mapDispatchToProps>;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisplaySelectedGifteeBoxConfigForBulkProject);
